<template>
  <div>
    <sub-menu
      :title="title"
      :routes="routes"
    ></sub-menu>

    <router-view></router-view>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters } from 'vuex'
import config from '../../config'

export default {
  data() {
    return {
      title: 'tools',
      routes:[
        { path: '/tools', title: 'economic_calendar' },
        // { path: '/tools/market-buzz', title: 'market_buzz' },
        { path: '/tools/technical-views', title: 'technical_views' },
        { path: '/tools/alpha-generation', title: 'alpha_generation'},
        { path: '/tools/newsletter', title: 'newsletter' },
        { path: '/tools/education', title:'education' },
      ],
    }
  },
  components: {
    SubMenu,
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      TotalDesposited: 'user/totalDeposited',
    }),
  },
  mounted() {
    if (this.TotalDesposited < 5000) return this.$router.push('/' + this.Language + '/' + config.defaultURL).catch(() => { })
  },
}
</script>
